module.exports = __webpack_public_path__ + "img/zoro.12a2f79e.svg";